// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreadcrumbsBaseItem_wrapper__7kRM2"};